import React from 'react';
import { createRefetchContainer, graphql } from 'react-relay';
import type AppConfig from '../domain/AppConfig';
import AppService from '../service/AppService';
import Price from './Price';

const appConfig:AppConfig = AppService.appConfig();

class ShippingPrice extends React.Component {

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }


  updateCartTotal() {
    // mp-web https://order.test.aperza.com/cart (to update total)
    let totalPriceNoShippingFee = document.getElementById('cart-totalPriceNoShippingFee');
    if (totalPriceNoShippingFee) {
      totalPriceNoShippingFee = parseInt(totalPriceNoShippingFee.textContent, 10)

      // smartphone + pc uses same class with different elements, update all
      const totalPrices = document.getElementsByClassName('cart-totalPriceWithShippingFee')
      for(var i = 0; i < totalPrices.length; i++) {
        let totalPrice = totalPrices.item(i);
        totalPrice.textContent = '¥' + this.numberWithCommas(this.totalShippingPrice + totalPriceNoShippingFee);
      }
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      modelIds:  this.props.modelIds,
      prefectureCode: this.props.prefectureCode,
      quantities: this.props.quantities,
    };
    this.totalShippingPrice = null;

  }

  handlePrefectureChange = (e) => {
    // console.log('Handling prefecture change', e.target.value);
    this.setState({prefectureCode: e.target.value});
  }

  handleQuantityChange = (e) => {
    console.log('Handling quantity change', e.target.value);
    this.setState({quantities: e.target.value});
  }

  componentWillUnmount() {
    if (document.getElementById('aperza-prefectures-for-shipping-price-component')) {
      document.removeEventListener('change', this.handlePrefectureChange, false);
    }

    if (document.getElementById('aperza-quantity-for-shipping-price-component')) {
      document.removeEventListener('change', this.handleQuantityChange, false);
    }

    const prefectureSelects = document.getElementsByClassName('aperza-prefectures-for-shipping-price-component-class');
    if (prefectureSelects && prefectureSelects !== 0) {
      for(var i = 0; i < prefectureSelects.length; i++) {
        let prefectureSelect = prefectureSelects.item(i);
        prefectureSelect.removeEventListener('change', this.handlePrefectureChange, false);
      }
    }

    const quantitySelects = document.getElementsByClassName('aperza-quantity-for-shipping-price-component-class');
    if (quantitySelects && quantitySelects !== 0) {
      for(var i = 0; i < quantitySelects.length; i++) {
        let quantitySelect = quantitySelects.item(i);
        quantitySelect.removeEventListener('change', this.handleQuantityChange, false);
      }
    }
  }

  componentDidMount() {
    if (document.getElementById('aperza-prefectures-for-shipping-price-component')) {
      document.getElementById('aperza-prefectures-for-shipping-price-component').addEventListener('change', this.handlePrefectureChange, false);
    }
    
    if (document.getElementById('aperza-quantity-for-shipping-price-component')) {
      document.getElementById('aperza-quantity-for-shipping-price-component').addEventListener('change', this.handleQuantityChange, false);
    }

    // if there are prefecture-class present, register those too
    const prefectureSelects = document.getElementsByClassName('aperza-prefectures-for-shipping-price-component-class');
    if (prefectureSelects && prefectureSelects !== 0) {
      for(var i = 0; i < prefectureSelects.length; i++) {
        let prefectureSelect = prefectureSelects.item(i);
        prefectureSelect.addEventListener('change', this.handlePrefectureChange, false);
      }
    }
    
    // if there are quantity-class present, register those too
    const quantitySelects = document.getElementsByClassName('aperza-quantity-for-shipping-price-component-class');
    if (quantitySelects && quantitySelects !== 0) {
      for(var i = 0; i < quantitySelects.length; i++) {
        let quantitySelect = quantitySelects.item(i);
        quantitySelect.addEventListener('change', this.handleQuantityChange, false);
      }
    }

    this.updateCartTotal();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

    this.updateCartTotal();
    if (this.state.prefectureCode !== prevState.prefectureCode ||
        this.state.quantities !== prevState.quantities) {
      console.log("fetching new data based on the following state", this.state)
      this._refetch(this.state);    // state is already updated
    } else {
      // do not update
    }
  }

  
  render() {    
    let modelIds = this.state.modelIds;
    let prefectureCode = this.state.prefectureCode;
    let quantities = this.state.quantities;

    if (!modelIds || !prefectureCode || !quantities) {
      console.log('Missing modelId/prefectureCode/quantity, not processing', this.state);
      return (null);
    }

    let data = this.props.shippingPriceResponseData.calculateShippingPrice;
    // console.log('Data is: ', data);
    if (!data) {
      console.log('Data is empty, not returning any shipping prices')
      return (null);
    }

    this.totalShippingPrice = data.totalShippingPrice;
    return (
      // convert the shippingPrice to string so that we don't get 'ASK' for 0 values
      <Price currency={'JPY'} price={'' + data.totalShippingPrice} openPrice={false} />
    );
  }

  _refetch = (state, instance) => {
    // this.setState({ loading: true});
    this.props.relay.refetch(
      {
        sellerProductModelIds: state.modelIds,
        prefectureCode: state.prefectureCode,
        quantities: state.quantities
      },
      null,  // We can use the refetchVariables as renderVariables
      (error) => {
        console.log('Finished fetching');
      },
      { force: false }  // Assuming we've configured a network layer cache, we want to ensure we fetch the latest data.
    );
  };
}

export default createRefetchContainer(
  ShippingPrice,
  {
    shippingPriceResponseData: graphql`
        fragment ShippingPrice_shippingPriceResponseData on ShippingPriceSchemaType
        @argumentDefinitions(
          sellerProductModelIds: {type: "String"},
          prefectureCode: {type: "String"},
          quantities: {type: "String"}
        ),
        {
          calculateShippingPrice (sellerProductModelIds: $sellerProductModelIds,
            prefectureCode: $prefectureCode,
            quantities: $quantities) {
                itemShippingPrices 
                {
                  sellerProductModelId
                  shippingPrice
                },
                totalShippingPrice
          }
        }
    `
  },
  graphql`
      query ShippingPriceRefetchQuery($sellerProductModelIds:String,
        $prefectureCode:String,
        $quantities:String
      ) {
        calculateShippingPrice {
              ...ShippingPrice_shippingPriceResponseData @arguments(
                sellerProductModelIds: $sellerProductModelIds,
                prefectureCode: $prefectureCode,
                quantities:$quantities)
        }
      }
  `
);